export function downloadFile (fileName, href) {
  const eleLink = document.createElement('a')
  eleLink.download = fileName
  eleLink.style.display = 'none'
  eleLink.href = href
  eleLink.click()
}



// WEBPACK FOOTER //
// ./src/utils/browser.js